import React, { useEffect, useMemo, useState } from "react";
import { useDispatch } from "react-redux";
import Notify from "../../Common/Notify";
import PUBNUB from "pubnub";
import Parse from "parse";
import config from "../../../config";
import { parseAction } from "../../../actions/REST";
import {
  generateQR,
  updateQueue,
  getQueueList,
  getQueue,
} from "../../../actions/PatientAction";
import QRCode from "react-qr-code";
import Modal from "../../Common/Modal";
import Logo from "../../../assets/images/logo-blue.png";
import "../../Pages/PatientTabs/PatientQueue/PatientQueue.css";
import "./QRQueueModal.css";
import { Tabs } from "material-ui";

let PubNub = null;
let subscribedChannels = null;

const QRQueueModal = ({ isOpen, onClose }) => {
  const dispatch = useDispatch();
  const [qrCode, setQRCode] = useState(null);
  const [current, setCurrent] = useState(null);
  const [usersList, setUserList] = useState([]);
  const [filter, setFilter] = useState("all"); 
  const [tab, setTab] = useState("QR");
  const [nameFilter, setNameFilter] = useState("");
  const [openConfirm, setOpenConfirm] = useState(false);

  const defQR = localStorage.getItem("current-qr-code");

  const listiningTo = {
    message: (m) => {
      var msg = m.message;
      console.log("ping:", m);
      if (msg.type === "get_queue_for_staff") {
        handleGetQueueList(defQR);

        setCurrent({
          ...current,
          current_serving: msg.currentServing,
          total_waiting: msg.total_waiting,
          contentAvailable: msg["content-available"],
        });
      }
    },
  };

  const tabs = {
    QR: "QR",
    CURRENT: "CURRENT",
    LIST: "LIST",
  };

  const activeClass = "hc-nav-link active";
  const inactiveClass = "hc-nav-link";

  useEffect(() => {
    if (defQR) {
      setQRCode(defQR);
      handleGetQueue(defQR);
      fetchPubNubKey(defQR);
    }
  }, [defQR]);

  const handleOnClose = () => {
    PubNub.removeListener(listiningTo);
    PubNub.unsubscribe({
      channels: subscribedChannels,
    });
    onClose();
  }

  useEffect(() => {
    const params = { queue_code: qrCode };

    if (qrCode) {
      handleGetQueueList(qrCode);
    }
  }, [qrCode]);

  const fetchPubNubKey = (defQR) => {
    parseAction("post", config.BASE_URL + "/parse/functions/getPubNubKeys")
      .then((keys) => {
        initializePubNub(keys.result, defQR);
      })
      .catch((error) => {
        console.log("error", error);
      });
  };

  const initializePubNub = (keys, defQR) => {
    PubNub = new PUBNUB({
      publish_key: keys.publishKey,
      subscribe_key: keys.subscribeKey,
      ssl: window.location.protocol.toLowerCase() === "https:",
      origin: "pubsub.pubnub.com",
      uuid: Parse.User.current().id,
      presenceTimeout: 120,
      heartbeatInterval: 30,
    });

    PubNub.addListener(listiningTo);
    subscribedChannels = ["queue_staff_channel_" + defQR];
    PubNub.subscribe({ channels: subscribedChannels });
  };

  const generateQRCode = () => {
    dispatch(generateQR()).then((res) => {
      const code = res.queuing_code.code;
      localStorage.setItem("current-qr-code", code);

      setQRCode(res.queuing_code.code);
      fetchPubNubKey();
    });
  };

  const handleGetQueueList = (qrCode) => {
    const params = { queue_code: qrCode };

    dispatch(getQueueList(params))
      .then((res) => {
        if (res && res.queue_list.length > 0) {
          setUserList(res.queue_list);
        }
      });
  }

  const handleNavBar = (newTab) => {
    if (newTab === tab) return;
    setTab(newTab);
  };

  const handleUpdateQueue = () => {
    const params = { code: qrCode };
    dispatch(updateQueue(params))
      .then((res) => {
        if (res && !res.error_message ) {
          Notify.info("Updated next queue");
          
          const wait = current.total_waiting > 0 ? current.total_waiting - 1 : 0;
          setCurrent({
            current_serving: res.now_serving,
            patient: res.patient_name,
            total_waiting: wait,
          });

        } else {
          Notify.info("No more queue available");
          setCurrent({
            current_serving: null,
            patient: "",
            total_waiting: 0,
          });
        }
      })
  }

  const handleGetQueue = (code) => {
    const params = { queue_code: code };
    dispatch(getQueue(params))
      .then((res) => {
        setCurrent(res);
      })
  }

  const handleStopQueue = () => {
    localStorage.removeItem("current-qr-code");
    setQRCode(null);
    setCurrent(null);
    handleNavBar(tabs.QR);
    setOpenConfirm(false);
    setUserList([]);
    PubNub.removeListener(listiningTo);
    PubNub.unsubscribe({
      channels: subscribedChannels,
    });
  }

  const filteredUsers = usersList.filter(item => {
    const statusMatch =
      filter === "all" || item.status === filter;

    const search = nameFilter.toLowerCase();

    const nameMatch =
      item.name.toLowerCase().includes(search);

    const numberMatch =
      String(item.mobile_number || "").includes(search);

    return statusMatch && (nameMatch || numberMatch);
  });

  return (
    <Modal shown={isOpen} onHide={handleOnClose}>
      <ModalHeader />
      <div className="QRQueueModal-navbar">
        <ul className="nav nav-pills nav-justified hc-nav-pills">
          <li className="nav-item">
            <a
              onClick={() => handleNavBar(tabs.QR)}
              className={tab === tabs.QR ? activeClass : inactiveClass}
              href="#"
            >
              <i className="fad fa-fw fa-qrcode fa-lg" style={{ marginTop: "3px" }}></i>
              {" "}QR
            </a>
          </li>
          <li className="nav-item">
            <a
              onClick={() => handleNavBar(tabs.CURRENT)}
              className={tab === tabs.CURRENT ? activeClass : inactiveClass}
              href="#"
            >
              <i className="fa fa-user-check" style={{ marginTop: "3px" }}></i>    
              {" "}Current
            </a>
          </li>
          <li className="nav-item">
            <a
              onClick={() => handleNavBar(tabs.LIST)}
              className={tab === tabs.LIST ? activeClass : inactiveClass}
              href="#"
            >
              <i className="fad fa-list" style={{ marginTop: "3px" }}></i>
              {" "}Queue List
            </a>
          </li>
        </ul>
      </div>
      <ModalBody style={{ margin: current ? "0px 30px" : "0px 30px", padding: "0px 1rem" }}>
        
        {tab === tabs.LIST && (
          <React.Fragment>
          <div className="Tab-Search-Container">
            <i className="fas fa-search"></i>
            <input
              onChange={(e) => setNameFilter(e.target.value)}
              id="search"
              type="search"
              autocomplete="off"
              list="search"
              placeholder="Search name / number / phone"
              // onFocus={() => checkFocus()}
              // onBlur={() => setFocus(false)}
            />
          </div>
          <div
            className="btn-list-tasks"
            style={{
              margin: "10px",
              display: "flex",
              flexDirection: "row",
            }}
          >
            <button
              className={`btn btn-sm`}
              style={{
                marginRight: 5,
                fontSize: "12px",
                color: "#ffffff",
                position: "relative",
                backgroundColor: filter === "all" ? "#f0ad4e" : "#C8C8C8",
              }}
              onClick={() => setFilter("all")}
            >
              All
            </button>
            <button
              className={`btn btn-sm`}
              style={{
                marginRight: 5,
                fontSize: "12px",
                color: "#ffffff",
                position: "relative",
                backgroundColor: filter === "waiting" ? "#f0ad4e" : "#C8C8C8",
              }}
              onClick={() => setFilter("waiting")}
            >
              Waiting
            </button>
            <button
              className={`btn btn-sm`}
              style={{
                marginRight: 5,
                fontSize: "12px",
                color: "#ffffff",
                position: "relative",
                backgroundColor: filter === "called" ? "#f0ad4e" : "#C8C8C8",
              }}
              onClick={() => setFilter("called")}
            >
              Serving
            </button>
            <button
              className={`btn btn-sm`}
              style={{
                marginRight: 5,
                fontSize: "12px",
                color: "#ffffff",
                backgroundColor: filter === "completed" ? "#f0ad4e" : "#C8C8C8",
              }}
              onClick={() => setFilter("completed")}
            >
              Done
            </button>
            <button
              className={`btn btn-sm`}
              style={{
                marginRight: 5,
                fontSize: "12px",
                color: "#ffffff",
                backgroundColor: filter === "skipped" ? "#f0ad4e" : "#C8C8C8",
              }}
              onClick={() => setFilter("skipped")}
            >
              Skipped
            </button>
          </div>
          <div className="queue-list-table shadow-sm" >
            {filteredUsers.length === 0 ? (
              <div className="em-container">
                <em>No Results Found</em>
              </div>
            ) : (
              filteredUsers.map((i, index) => (
                <ItemQRCode
                  data={i}
                  index={index}
                />
              ))
            )}
          </div>
          </React.Fragment>
        )}

        {tab === tabs.QR && (
          <div className="container-main">

            <div className="code-qr">
              {qrCode ? (
                <QRCode value={"test-text"} size={300} />
              ) : (
                <div class="empty-qr">
                  <i class="fas fa-qrcode fa-2x" />
                  <span>QR code will appear here</span>
                </div>
              )}
            </div>

            {qrCode ? (
              <React.Fragment>
                <div className="code-desc">Scan QR code or click on link</div>
                <a
                  className="footer-brand"
                  href={`http://localhost:3000/patient-queue/${qrCode}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ cursor: "pointer" }}
                >
                  <img className="d-none d-sm-inline" width="40" height="40" src={Logo} alt="H"></img>
                  <span className="hc-primary-text d-none d-md-inline" style={{ fontWeight: "500" }}>
                    HUBCHART
                  </span>
                </a>
              </React.Fragment>
            ) : (
              <button
                type="button"
                className="btn btn-primary btn-circle btn-large"
                style={{
                  width: "100%",
                }}
                onClick={() => generateQRCode()}
              >
                Start Queue & Generate QR
              </button>
            )}
          </div>
        )}

        {tab === tabs.CURRENT && (
          <div className="QRQueueModal-current">
            {current ? (
              <div className="QRQueueModal-curret-main">
                <div style={{ fontWeight: "bold" }}>CURRENT NUMBER</div>
                <span>
                  {current.current_serving ? "000" + current.current_serving : "--"}
                </span>
                <span>{current.patient ? "Patient: " + current.patient : ""}</span>
              </div>
            ) : (
              ""
            )}
            <button
              className="btn btn-primary hc-bg-primary btn-circle btn-large"
              onClick={() => handleUpdateQueue()}
            >
              Next Patient
            </button>
            <div className="queue-btn-container">
              <button
                className="btn btn-primary hc-bg-primary btn-circle btn-large"
                // onClick={() => handleUpdateQueue()}
              >
                Skip
              </button>
              <button
                className="btn btn-danger hc-bg-danger btn-circle btn-large"
                onClick={() => setOpenConfirm(true)}
              >
                Stop Queue
              </button>
            </div>
            <div className="current-queue-details">
              <span>TOTAL WAITING</span>
              <span>Estimated Time</span>
              <span>{current ? current.total_waiting : "0"}</span>
              <span>25min</span>
            </div>
          </div>
        )}
        
      </ModalBody>
      <ModalFooter></ModalFooter>
      {openConfirm && (
        <Confirmation
          handleStopQueue={() => handleStopQueue()}
          onClose={setOpenConfirm}
        />
      )}
    </Modal>
  );
};


const ItemQRCode = (props) => {
  return (
    <a
      className="dropdown-item d-flex flex-row item-result"
      href="#"
      style={{ border: "1px solid rgb(229, 229, 229)", placeItems: "center" }}
    >
      <div>
        <span
          style={{
            // background: "rgb(232, 240, 254)",
            position: "relative",
            top: "-1px",
            color: "white",
            padding: "10px",
            fontSize: "small",
          }}
          className="badge badge-secondary mx-1"
        >
          000{props.data.ticket_number}
        </span>
      </div>
      <div>
        <div className="ml-1">
          {props.data.name}
        </div>
        <div className="ml-1 text-small" style={{ color: "grey" }}>
          {props.data.mobile_number}
        </div>
      </div>
      <div className="text-secondary text-xs" style={{ marginLeft: "auto" }}>
        <QueueStatus status={props.data.status} />
      </div>
    </a>
  )
}

const QueueStatus = ({ status = ""}) => {
  const nameClass =
    status === "completed" ? "badge badge-success" :
    status === "called" ? "badge badge-primary" :
    status === "waiting" ? "badge badge-secondary text-grey" : "";
    
  return (
    <div
      className={nameClass}
      style={{
        position: "relative",
        top: "-1px",
        color: "white",
        padding: "10px",
        fontSize: "x-small",
      }}
    >
      {status.toUpperCase()}
    </div>
  )
}

const Confirmation = ({ handleStopQueue, onClose = () => {} }) => {
  return (
    <div className="assignment-notify-container">
      <div className="attention-notify-box" style={{ width: "auto" }}>
        <div className="save-changes-flex">
          <h6 style={{ fontWeight: "bold" }}>Stop current Queue ?</h6>
          <h6>This will delete all current waiting queue.</h6>
          <div style={{ textAlign: "right", marginTop: 10 }}>
            <button
              type="button btn-sm"
              style={{ marginRight: "10px" }}
              className="btn btn-danger"
              onClick={() => handleStopQueue()}
            >
              Stop
            </button>
            <button 
              type="button btn-sm" 
              className="btn btn-hubchart btn-hubchart-close"
              onClick={() => onClose(false)}
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

const ModalHeader = () => {
  return (
    <div className="modal-header">
      <h5 className="text-primary mb-0" style={{ fontSize: "1.25rem" }}>
        <i className="fas fa-qrcode mr-1"></i>
        QR CODE
      </h5>
      <button type="button" className="close" data-dismiss="modal" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
  );
};

const ModalBody = ({ children, style = {} }) => {
  const styles = {
    ...style,
  };

  return (
    <div className="modal-body" style={styles}>
      {children}
    </div>
  );
};

const ModalFooter = ({ children }) => {
  return <div className="modal-footer">{children}</div>;
};

export default QRQueueModal;
